import React from 'react';

var Minus = function Minus(props) {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13 13",
    style: props.style
  }, /*#__PURE__*/React.createElement("line", {
    className: "icon-minus",
    x1: "11.5",
    y1: "6.5",
    x2: "1.5",
    y2: "6.5"
  }));
};

export default Minus;